import React, {Component} from 'react'

class Timer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            time: props.time
        }


        const x = setInterval(() => {
            this.setState({time: this.state.time - 1000})
        }, 1000)

        setTimeout(() => {
            clearInterval(x)
            this.props.onFinished()
        }, props.time)


    }

    render() {
        const percentage = (this.props.time - this.state.time ) / this.props.time * 100;

        return (


            <div className="progress white">
                <div className="determinate blue" style={{width: percentage+"%"}}></div>
            </div>


        )
    }
}

export default Timer

